export const REWARD_VALUE = 500;
export const REWARD_VALUE_KZ = 2500;
